import React from 'react';
import {TouchableOpacity, View} from 'react-native';
import {noop} from 'lodash';

import Button from '/component/base/Button';
import BasePopover from '/component/base/Popover';
import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import testProperties from '/util/testing/testProperties';

import {styles} from './MergeProfilePopover.style';
interface MergeProfilePopoverProps {
  tt: (key: string, fallback: string) => string;
  currentScreen: string;
  onSubmit: () => void;
  onCancel: () => void;
  popoverClose: () => void;
  destinationURL: string;
}

export const MergeProfilePopover: React.FC<MergeProfilePopoverProps> = ({
  tt,
  onSubmit = noop,
  popoverClose = noop,
}) => {
  return (
    <BasePopover style={styles.modalView} padded>
      <TouchableOpacity
        {...testProperties(null, true)}
        accessibilityRole="button"
        accessibilityLabel="Merge profile confirmation">
        <View
          style={styles.modalBody}
          {...testProperties(DownlineProfile.mergeConfirm)}>
          <Text
            variant="heading"
            style={styles.headerText}
            {...testProperties(DownlineProfile.mergeConfirmHeader)}>
            {tt('confirmation', 'Are you sure you want to merge this profile?')}
          </Text>
        </View>
        <View style={styles.modalFooter}>
          <Button
            onPress={onSubmit()}
            style={{
              base: styles.buttonBox,
            }}
            testID={DownlineProfile.mergeConfirmMergeProfilesButton}>
            Merge Profile
          </Button>
          <Button
            type="textLink"
            onPress={popoverClose}
            style={{
              base: styles.buttonBox,
              // @ts-expect-error TS(2339): Property 'textStyle' does not exist on type '{ bas... Remove this comment to see the full error message
              text: styles.textStyle,
            }}
            testID={DownlineProfile.mergeConfirmCancelButton}>
            Cancel
          </Button>
        </View>
      </TouchableOpacity>
    </BasePopover>
  );
};

export default withTranslation('DeleteProfilePopoverModal')(
  MergeProfilePopover,
);
